// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Callout-module--cds--assistive-text--33e6c";
export var cdsVisuallyHidden = "Callout-module--cds--visually-hidden--1861e";
export var firstColumn = "Callout-module--firstColumn--52086";
export var grid = "Callout-module--grid--61837";
export var hideFeedback = "Callout-module--hide-feedback--481b7";
export var row = "Callout-module--row--0dff4";
export var secondColumn = "Callout-module--secondColumn--3d663";
export var showFeedback = "Callout-module--show-feedback--ed0f7";
export var skeleton = "Callout-module--skeleton--4ccb2";